/**
 * Utility to generate slugs.
 * This is based on time (ms) so this is not a safe uid.
 */
export default function generateSlug() {
	return new Date().getTime().toString(36);
}
